import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'aggerrmsgCombine',
})

export class AggregationErrorMsgCombinePipe implements PipeTransform {
    transform(aggregatefunctionmsg:any,aggregateFunctionFieldmsg:any,thresholdOperatormsg:any,thresholdValuemsg:any):any {
        let allErrorsmsg = {...aggregatefunctionmsg, ...aggregateFunctionFieldmsg,...thresholdOperatormsg,...thresholdValuemsg}
        return allErrorsmsg
    }
}